import { Injectable } from '@angular/core';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import { Observable } from 'rxjs';
import * as pdfjsLib from 'pdfjs-dist';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() {
    GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
  }

  extractTextFromPDF(file: File): Observable<string[]> {
  
    const fileReader = new FileReader();
    
    return new Observable(observer => {
      fileReader.onload = async (e) => {
        const pdfData = new Uint8Array(e.target!.result as ArrayBuffer);
        const pdf = await pdfjsLib.getDocument(pdfData).promise;
        const numPages = pdf.numPages;
        
        const textResult: string[] = [];
  
        // Gehe durch jede Seite der PDF und extrahiere den Text
        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const textContent = await page.getTextContent();
          const pageText = textContent.items.map((item: any) => item.str).join(' ');
  
          // Speichere den Text der Seite im Array
          textResult.push(pageText);
        }
  
        // Gib das Array mit allen Seiten zurück
        observer.next(textResult);
        observer.complete();
      };
  
      fileReader.readAsArrayBuffer(file);
    });
  }

  async getPdfPageCount(file: File): Promise<number> {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      const pdf = await pdfjsLib.getDocument({ data: uint8Array }).promise;
      return pdf.numPages;
    } catch (error) {
      console.error('Fehler beim Laden der PDF-Datei:', error);
      throw error;
    }
  }
}
